var EcommerceEventEnum;
(function (EcommerceEventEnum) {
    EcommerceEventEnum["PURCHASE"] = "purchase";
    EcommerceEventEnum["REFUND"] = "refund";
})(EcommerceEventEnum || (EcommerceEventEnum = {}));
export class GoogleAnalytics4 {
    static sendEcommercePurchaseEvent(props) {
        this.sendEcommerceEventData({ event: EcommerceEventEnum.PURCHASE, ecommerce: props });
    }
    static sendEcommerceRefundEvent(props) {
        this.sendEcommerceEventData({ event: EcommerceEventEnum.REFUND, ecommerce: props });
    }
    static sendEcommerceEventData(props) {
        this.dataLayer.push({ ecommerce: null });
        this.dataLayer.push(props);
    }
}
GoogleAnalytics4.dataLayer = window.dataLayer;
